<template><DashboardPanel title="近12个月收缴率趋势" meta="单位：%"><div ref="chart" class="collection-trend"></div></DashboardPanel></template>
<script>
import * as echarts from 'echarts'
import DashboardPanel from './DashboardPanel.vue'
import { dashboardTooltip, formatNumber, percentValue, toNumber } from '../dashboardFormat'

export default {
  name: 'CollectionRateTrend',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  data: () => ({ chart: null }),
  watch: { data: { deep: true, handler() { this.renderChart() } } },
  mounted() {
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    renderChart() {
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      const trend = Array.isArray(this.data.trend) ? this.data.trend : []
      const values = trend.map(item => percentValue(toNumber(item.receivedAmount), toNumber(item.receivableAmount)))
      this.chart.setOption({
        grid: { top: 26, right: 18, bottom: 28, left: 42 },
        tooltip: dashboardTooltip({
          trigger: 'axis',
          formatter: params => {
            const item = (Array.isArray(params) ? params[0] : params) || {}
            return `${item.axisValue || ''}<br/>${item.marker || ''}收缴率：${formatNumber(item.value, 1)}%`
          }
        }),
        xAxis: { type: 'category', data: trend.map(item => String(item.bucket || '').slice(5)), axisLine: { lineStyle: { color: '#35586e' } }, axisTick: { show: false }, axisLabel: { color: '#9cb1c0', fontSize: 10 } },
        yAxis: { type: 'value', min: 0, max: 100, interval: 50, axisLabel: { formatter: '{value}%', color: '#9cb1c0', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(69,124,160,.15)', type: 'dashed' } } },
        series: [{ name: '收缴率', type: 'line', data: values, symbolSize: 8, smooth: true, lineStyle: { color: '#35aaf1', width: 3 }, itemStyle: { color: '#fff', borderColor: '#2fa9f0', borderWidth: 2 }, areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(32,151,226,.24)' }, { offset: 1, color: 'rgba(32,151,226,0)' }] } }, label: { show: true, position: 'top', formatter: params => `${formatNumber(params.value, 1)}%`, color: '#e0e9ef', fontSize: 9 } }]
      }, true)
    },
    resizeChart() { if (this.chart) this.chart.resize() }
  }
}
</script>
<style scoped>.collection-trend{width:100%;height:100%;}</style>
